/**
 * Error Boundary Component (TASK-056)
 *
 * Wraps app with Sentry error boundary for catching React errors.
 */
import * as Sentry from '@sentry/react';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';

export const ErrorBoundary = Sentry.withErrorBoundary(
  ({ children }: { children: React.ReactNode }) => children,
  {
    fallback: ({ error, resetError }) => {
      const errorMessage = error instanceof Error ? error.message : 'Произошла непредвиденная ошибка';

      return (
        <div className="flex items-center justify-center h-screen">
          <Alert variant="destructive" className="max-w-lg">
            <AlertTitle>Что-то пошло не так</AlertTitle>
            <AlertDescription className="mt-2">
              <p className="mb-4">{errorMessage}</p>
              <div className="space-x-2">
                <Button onClick={resetError}>Попробовать снова</Button>
                <Button
                  variant="outline"
                  onClick={() => (window.location.href = '/')}
                >
                  На главную
                </Button>
              </div>
            </AlertDescription>
          </Alert>
        </div>
      );
    },
    showDialog: false,
  }
);
